module.exports = __webpack_public_path__ + "img/PL09072.89599ad8.png";